import CityPageTemplate from "../city-template/CityPageTemplate";
import { georgetownConfig } from "./data";

export default function GeorgetownPage() {
  return <CityPageTemplate config={georgetownConfig} />;
}